/**
 * NoRole
 *
 * Displays a friendly message when a signed-in user has no role assigned.
 * Renders a minimal header and a centered card with guidance to contact an admin.
 */
import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import NoRoleIcon from "../../assets/icons/no-role-icon.svg";
import Header from "../home/header/header";

type NoRoleProps = { isNoRole: boolean };

const NoRole: React.FC<NoRoleProps> = ({ isNoRole }) => {
  return (
    <>
      <Header isNoRole={isNoRole} />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="92vh"
        bgcolor="#F9FAFB"
      >
        <Card
          sx={{
            maxWidth: 500,
            p: 4,
            textAlign: "center",
            border: "1.38px solid #E9E9E8",
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ gap: 2 }}>
            <Box display="flex" justifyContent="center" mb={2}>
              <img
                src={NoRoleIcon}
                alt="No Role Icon"
                style={{ width: 68, height: 68 }}
              />
            </Box>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#0E0D09" }}
              mb={1}
            >
              No Access Assigned
            </Typography>
            <Typography variant="body1" sx={{ color: "#4E4B44" }}>
              Your account is active, but no role has been assigned yet.
            </Typography>
            <Typography variant="body1" sx={{ color: "#4E4B44" }}>
              Please contact the system administrator to get access.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default NoRole;
